import {InternalAnalyticsService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _InternalAnalyticsService = new InternalAnalyticsService({client});
export {_InternalAnalyticsService as InternalAnalyticsService};
